<script>
import Footer from './footer.vue';

export default {
    components: {
        Footer
    },
}
</script>

<template lang="pug">
.forkiss-my-order-container
    router-view
    Footer(activeId="my-order")

</template>

<style lang="less" scoped>
.forkiss-my-order-container {
    position: relative;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/my-order.vue